<template>
    <main-content with_go_back_bar>
        <div>
            <transactions-psp-report-filter
                    :action="filterAction"
                    :exportExcel="exportToExcel"
            >
            </transactions-psp-report-filter>
            <div>
                <kt-row>
                    <kt-col lg="3" md="3" xs="12">
                        <div class="kt-portlet">
                            <div class="kt-portlet__body" style="color: black; background-color: #fff">
                                <h6> {{ $t('label.last_updated') }}</h6>
                                <div class="text-center">
                                    <h5 class="fix-margin">
                                        {{ subsetPSPReportStatistics.last_updated }}
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div class="position-absolute" style="left:20px;top:13px;cursor: pointer;">
                            <button class="no-border" @click="updateReport($event, query)" >
                                <i class="fa flaticon-refresh" aria-hidden="true"
                                   style="font-size: 1.6em; color: #0f9af0"
                                   :title="$t('label.reportUpdate')"
                                >
                                </i>
                            </button>
                        </div>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <div class="kt-portlet">
                            <div class="kt-portlet__body" style="color: black; background-color: #fff">
                                <h6> {{ $t('label.terminal_title') }}</h6>
                                <div class="text-center">
                                    <h4 class="fix-margin">
                                        {{ subsetPSPReportStatistics.terminal_title }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <div class="kt-portlet">
                            <div class="kt-portlet__body" style="color: black; background-color: #fff">
                                <h6> {{ $t('label.total_transactions') }}</h6>
                                <div class="text-center">
                                    <h4 class="fix-margin">
                                        {{ subsetPSPReportStatistics.total_transactions }}
                                        <span style="font-size: 1.5rem">
                                        {{' ' + $t('currency.rial')}}
                                    </span>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <div class="kt-portlet">
                            <div class="kt-portlet__body" style="color: black; background-color: #fff">
                                <h6>{{ $t('label.succeeded_transactions_number') }}</h6>
                                <div class="text-center">
                                    <h4 class="fix-margin"> {{ subsetPSPReportStatistics.number }} </h4>
                                </div>
                            </div>
                        </div>
                    </kt-col>
                </kt-row>
            </div>
            <div>
                <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
            </div>
        </div>
    </main-content>
</template>

<script>
import $ from 'jquery'
import { ApiUrl } from '@/common/api.service'
import columns from './datatable/transactions-psp-report-columns'
import transactionsReportFilter from './components/transactions-psp-report-filter'
import { AuthorizationHeader } from '@/common/jwt.service'
import mainContent from '@/components/main-content'
import {mapGetters} from "vuex";
import store from '@/store'
import axios from "axios";
import { KTApp } from '@/plugins/core/app'
import toastr from "toastr";
import { i18n } from '@/plugins/i18n'

export default {
        name: "gateway_transactions_report",
        components: {
            mainContent,
            'transactions-psp-report-filter': transactionsReportFilter
        },
        data() {
            return {
                headerAction: {
                    left: '10px',
                    top: '10px',
                    position: 'absolute'
                },
                query: {},
                subset_user_id: this.$route.params.user_id,
                shop_id: null
            }
        },
        computed: {
            ...mapGetters('marketing', [
                'status',
                'subsetPSPReportStatistics',
            ]),
            datatableProps() {
                return {
                    id: "datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path(`marketing/subset-psp-transactions-report/${this.subset_user_id}`),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: (res) => {
                                    return res.data.data.data
                                },
                                params: {
                                    query: this.query
                                },
                                success: function (res) {
                                    let paramss = {
                                        subset_user_id : res.data.data.subset_user_id,
                                        shop_id: res.data.data.shop_id
                                    }
                                    store.dispatch('marketing/fetchPSPReportStatistics', paramss)
                                }
                            }
                        },
                        pageSize: 15,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns
                }
            }
        },
        methods: {
            filterAction(e, query) {
                query.reportUpdate = false
                this.shop_id = query.shop_id
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
                this.fetchReportStatistics(this.subset_user_id, this.shop_id)
            },
            exportToExcel(e, query){
                this.shop_id = query.shop_id
                let btn = $('#export_psp_transations_btn')
                KTApp.progress(btn)

                this.query = query
                axios({
                    url: ApiUrl.path(`marketing/export-transactions-psp-report/${this.subset_user_id}`),
                    method: 'GET',
                    params: this.query,
                    responseType: 'blob',
                }).then((response) => {
                    KTApp.unprogress(btn)
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'transactions.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                }).catch(({response}) => {
                    this.toastr.error(i18n.t('message.an_error_accord'))
                    KTApp.unprogress(btn)
                })
            },
            fetchReportStatistics(hashid, shop_id) {
                let params = {
                    subset_user_id : hashid,
                    shop_id: shop_id
                }
                store.dispatch('marketing/fetchPSPReportStatistics', params)
            },
            updateReport(e, query) {
                query.reportUpdate = true
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            }
        },
        mounted() {
            store.dispatch('marketing/fetchSubsetTerminals', this.subset_user_id)
        },
    }
</script>

<style>
    .no-border {
        border: none;
        background: none;
    }
</style>